// Routes owned by the Report module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const reportPaths = {
    reportCustomer: '/reports/customers',
    reportService: '/reports/services',
    reportIncome: '/reports/incomes',
    reportRevenue: '/reports/revenues',
    reportBusinessTargets: '/reports/business-targets',
    reportFinance: '/reports/financials',
    reportTargetAnalytics: '/reports/targets-analytics',
    reportAnalytics: '/reports/analytics',
    reportVpbank: '/reports/vpbank',
    reportReceivables: '/reports/receivables',
    reportReceivableCustomer: '/reports/receivables/customers/:id',
} as const
